import { Injector } from "@angular/core";
import { SimpleSearchListNode } from "../../SimpleSearchListNode"
import { ApprovedSubtanceEntityListView } from "../../../Data/MedicinalProductData/ApprovedSubstanceEntityListView";
import { EntityEnum } from "../../EntityEnum";
import { ApprovedSubstanceAutoUploadEntity } from "../Entity/ApprovedSubstanceAutoUploadEntity";
import { BaseNode } from "../../BaseNode";


export class TreeNodeMedicinalProductsApprovedSubstance extends SimpleSearchListNode {
useHist: boolean = false;
constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new ApprovedSubtanceEntityListView(items), "Approved Substances", useHist?EntityEnum.approvedSubstanceHist : EntityEnum.approvedSubstance);
        this.useHist = useHist;
    }

    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${model.stamp_nullif != null?'Nullified - ':model.replaced_stamp?'':'Current '}Approved - ${model.ev_Code} - ${model.substancename}`;
        return this.addChildNode(ApprovedSubstanceAutoUploadEntity,labelTemplate, this,model, this.useHist, false, false);
    }

    override getCriteriaFields(): string[] {
        return ['ev_Code','substancename'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for substance records available in XEVMPD";
    }

    override getPlaceHolderToolTipTemplate(): string {
        return "The search result will display the preferred name of the substance and the assigned EV Code"
    }
}